import { Component, Vue, VModel, Prop } from 'vue-property-decorator';
import { isNumber } from 'lodash';
import { NOTIFICATION } from '@/constants';
import { SelectionOptions, AssessmentPeriodDTO, ProjectDTO } from '@/models';
import ProjectExporting from '@/services/project-exporting';
import RewardPeriodsExport from '@/services/reward-periods-export';
import FilterDropdown from '@/components/common/filter-dropdown/FilterDropdown.vue';

@Component({
  components: {
    FilterDropdown,
    RewardPeriodsExport
  }
})
export default class RewardManagement extends Vue {
  @VModel() modalShown!: boolean;
  @Prop({ default: () => [] }) assessmentPeriods: AssessmentPeriodDTO[];
  @Prop() projectInfo: ProjectDTO;

  private isExporting = false;
  private selectedPeriodIds: string[] = [];

  get periodsOptions(): SelectionOptions {
    const projectAssessmentPeriodIds = this.projectInfo?.projectAssessments?.map(pa => pa.assessmentPeriodId);
    const filteredPeriods =
      this.assessmentPeriods?.filter(ap => isNumber(ap?.id) && projectAssessmentPeriodIds.includes(ap?.id)) || [];
    return filteredPeriods.map(({ name, id = '-1' }) => ({
      text: name,
      value: id?.toString()
    }));
  }

  get isDisabled(): boolean {
    return this.isExporting || !this.assessmentPeriods?.length;
  }

  async onModalConfirm(): Promise<void> {
    this.isExporting = true;

    const filteredData = !this.selectedPeriodIds.length
      ? this.assessmentPeriods
      : this.assessmentPeriods.filter(ap => isNumber(ap?.id) && this.selectedPeriodIds.includes(ap?.id?.toString()));
    const averageSatAndComplexity = this.$store.getters['project/averageSatAndComplexity'];

    const projectExport = new ProjectExporting(filteredData, averageSatAndComplexity);
    projectExport.exportXLSXSingleProject(this.projectInfo).finally(() => {
      this.isExporting = false;
      const notificationInfo = {
        showing: true,
        type: NOTIFICATION.TYPE.success,
        title: NOTIFICATION.TEXT.exportDataSuccess,
        content: [],
        icon: NOTIFICATION.ICON.success,
        multiline: false,
        height: 0
      };
      this.$store.commit('notification/setNotification', notificationInfo);
    });
  }

  onModalCancel(): void {
    this.modalShown = false;
  }

  onSelectedPeriodsChange(selectedValues: string[]): void {
    this.selectedPeriodIds = selectedValues;
  }
}
